import React, { ReactNode } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/styles";
import { themeWithCustoms } from "./themes";
import { Footer } from "./Footer";
import Header from "./Header";
import { MobileAppsRedirectImage } from "../Pages/TicketReceiving/MobileAppsRedirectImage";
import { MobileAppsRedirectFooter } from "../Pages/TicketReceiving/MobileAppsRedirectFooter";
import { connect } from 'react-redux';
import {IEnvironment} from '../../interface/IShareInfo';


const useStyles = makeStyles(({ palette, breakpoints }) => {
  return createStyles({
    root: {
      minHeight: "100vh",
      zIndex: 1,
      overflow: "hidden",
      position: "relative",
      width: "100%",
      backgroundColor: "#f3f3f3",
      [breakpoints.down("sm")]: {
        backgroundColor: "white"
      }
    },
    contentContainer: {
      display: "flex",
      justifyContent: "center",
      marginLeft: "auto",
      marginRight: "auto",
      width: 850,
      backgroundColor: "#ffffff",
      borderRadius: 5,
      boxShadow: "0 12px 44px 0 rgba(0, 0, 0, 0.1)",
      border: "solid 1px rgba(0, 0, 0, 0.2)",
      marginTop: 40,
      paddingBottom: 40,
      // marginBottom: 40,
      [breakpoints.down("md")]: {
        width: 728
      },
      [breakpoints.down("sm")]: {
        width: "100%",
        borderRadius: 0,
        boxShadow: "none",
        border: "none",
        marginTop: 0
      }
    },
    contentBox: {
      width: 496,
      // marginBottom: 40,
      [breakpoints.down("sm")]: {
        maxWidth: 496,
        width: "100%",
        paddingLeft: 20,
        paddingRight: 20
      }
    }
  });
});

interface IProps {
  children: ReactNode;
  env: IEnvironment;
}

const LayoutWithHeaderControl = (props: IProps) => {
  const { children } = props;
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <Header env={ props.env } />
      <div className={classes.contentContainer}>
        <div className={classes.contentBox}>{children}</div>
      </div>
      <MobileAppsRedirectFooter />
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    env: state.env
  };
};

export const LayoutWithHeader = connect(
  mapStateToProps,
  null)(LayoutWithHeaderControl);



